/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum TemplateType {
    Application = 'Application',
    Baremetal = 'Baremetal',
    Cloud = 'Cloud',
    Configuration_Management = 'Configuration Management',
    Container = 'Container',
    Continuous_Integration = 'Continuous Integration',
    DataTransferMonitoring = 'DataTransferMonitoring',
    DevOps = 'DevOps',
    ITSM = 'ITSM',
    Log_Management = 'Log Management',
    Monitoring = 'Monitoring',
    NFV = 'NFV',
    Notifications = 'Notifications',
    Orchestration = 'Orchestration',
    Patch_Management = 'Patch Management',
    SDN = 'SDN',
    Source_Code_Management = 'Source Code Management',
    Vulnerability_Assessment = 'Vulnerability Assessment'
}
